import { render, staticRenderFns } from "./AppartmentView.vue?vue&type=template&id=201c54fe&scoped=true&"
import script from "./AppartmentView.vue?vue&type=script&lang=ts&"
export * from "./AppartmentView.vue?vue&type=script&lang=ts&"
import style0 from "./AppartmentView.vue?vue&type=style&index=0&id=201c54fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201c54fe",
  null
  
)

export default component.exports